<template>
  <div class="pub-page">
    <div class="pub-header d-flex align-items-center justify-content-between">
      <div>
        <text class="title me-1">{{$route.meta.title}}</text>
        <el-input clearable style="width: 200px;" placeholder="请输入关键词"
                  v-model="params.tag"
                  @clear="reset"
                  @change="getList(true)"
                  class="me-1"></el-input>
        <el-button type="primary"  @click="getList(true)">搜索</el-button>
        <el-button type=""  @click="reset">重置</el-button>
      </div>
    </div>
    <div class="pub-center">
      <el-table border scrollbar-always-on   :data="list" style="width: calc(100% - 30px);position: absolute;left: 15px;top:10px;padding-bottom: 30px"  v-loading="loading">

        <el-table-column label="标签"   >
          <template #default="scope">
            {{scope.row.Tag || '-'}}
          </template>
        </el-table-column>
        <el-table-column label="日志内容" >
          <template #default="scope">
            {{scope.row.Content || '-'}}
          </template>
        </el-table-column>
        <el-table-column label="日志时间" >
          <template #default="scope">
            {{scope.row.CreatedTime || '-'}}
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pub-footer d-flex align-items-center justify-content-center">
      <el-pagination  v-show="total>0" background
                      layout="total, sizes, prev, pager, next"
                      :page-sizes="[10, 20, 30, 40]"
                      :total="total"
                      v-model:current-page="params.current"
                      @size-change="handleSizeChange"
                      @current-change="handleCurrentChange"/>
    </div>
  </div>
</template>

<script setup>
import {onMounted, reactive, ref} from "vue";
import AddTopicModel from "@/components/AddTopicModel"
import {ElMessage,ElMessageBox} from "element-plus";
const dialogVisible = ref(false)
const choisedItem = ref()
import {formatTime} from "@/utils/dateFun";
import {needInitQueryFun} from "@/utils/common";
import {getSystemLogs} from "@/api/logsAdmin";
const params = reactive({
  pageSize:10,
  current:1,
  tag:null
})
const total = ref(0)
const list = ref([])
const loading = ref(false)
onMounted(()=>{
  getList()
})
const reset = ()=>{
  params.tag = ""
  getList(true)
}
// 列表
const getList = async (init)=>{
  if(init){
    params.current = 1
  }
  loading.value = true
  const res = await getSystemLogs(params)
  loading.value = false
  if(res.success){
    total.value = res.total
    let data = res.data || []
    data.forEach(item=>{
      //  创建时间
      if(item.CreatedAt){
        item.CreatedTime = formatTime(item.CreatedAt)
      }
    })
    list.value = data
  }else{
    return  ElMessage.warning("获取列表失败")
  }
}

// 页码改变
const handleSizeChange = (event) => {
  if(params.pageSize !==event){
    params.current = 1
    params.pageSize = event
    getList()
  }
}
const handleCurrentChange = ()=>{
  getList()
}
</script>

<style scoped lang="scss">


</style>
